import { render, staticRenderFns } from "./ScheduleMessages.vue?vue&type=template&id=190d9ebc&scoped=true&"
import script from "./ScheduleMessages.vue?vue&type=script&lang=js&"
export * from "./ScheduleMessages.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleMessages.vue?vue&type=style&index=0&id=190d9ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190d9ebc",
  null
  
)

export default component.exports